/// <reference path='../frontend/global.types.ts' />
import './vendor/jquery';
// Custom fork, see https://github.com/defunkt/jquery-pjax/compare/master...parsys-telemedicine:jquery-pjax:master
import './vendor/jquery.pjax-2.0.1';

import 'bootstrap-sass';
import 'datatables.net';
import 'datatables.net-bs';
// Responsive needs to be imported before ColReorder / ColResize.
import 'datatables.net-responsive';
import 'datatables.net-responsive-bs';
import 'datatables.net-colreorder';
import 'datatables.net-colreorder-bs';
import 'datatables.net-colresize-unofficial';
import 'select2';
import 'select2/dist/js/i18n/fr';

// Tree-shaking Font Awesome SVG icons.
import '@fortawesome/fontawesome-free/js/fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faClock,
  faCommentAlt,
  faFile,
} from '@fortawesome/free-regular-svg-icons';
import {
  faAngleDown,
  faBell,
  faCheck,
  faDownload,
  faEdit,
  faEnvelope,
  faExpandArrowsAlt,
  faExternalLinkAlt,
  faInfoCircle,
  faMars,
  faPaperclip,
  faPlusCircle,
  faSpinner,
  faSquare,
  faTimes,
  faTrash,
  faUser,
  faUserPlus,
  faUsers,
  faVenus,
  faVenusMars,
  faMapLocationDot,
} from '@fortawesome/free-solid-svg-icons';

import './locale/i18n.en';
import './locale/i18n.fr';

import './reactTreeMounting';
import './compatibility';
import './consultations';
import './datatables';
import './draft';
import './employees';
import './filesUpload';
import './forms';
import './init';
import './lists';
import './modalCarousel';
import './modals';
import './patients';
import { initPjax } from './pjax';
import './reports';

library.add(
  faAngleDown,
  faBell,
  faClock,
  faCheck,
  faCommentAlt,
  faDownload,
  faEdit,
  faEnvelope,
  faExpandArrowsAlt,
  faExternalLinkAlt,
  faFile,
  faInfoCircle,
  faMars,
  faPaperclip,
  faPlusCircle,
  faSpinner,
  faSquare,
  faTimes,
  faTrash,
  faUser,
  faUserPlus,
  faUsers,
  faVenus,
  faVenusMars,
  faMapLocationDot,
);

// needs to happen here and not on APP_INIT, otherwise the pjax logic breaks
initPjax();
